
export class TimePeriods {

    key: string;
    label: string;
    start_date: string;
    end_date: string;

    constructor() {
        this.key = "";
        this.label = "";
        this.start_date = "";
        this.end_date = ""
    }

}